var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { reduxBind } from 'badphraim/ui/LitReduxMixinBase';
import { isSuccessHTTP } from 'boost-api/APIRestClient';
import { MembersignupAPI } from 'boost-api/boost/signup/membersignup/MembersignupAPI';
import { css, html, LitElement } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { BoostPortalStore } from '../redux/BoostPortalStore';
import { litReduxBoostPortalMixin } from '../redux/LitReduxBoostPortalMixin';
import { SnackBar } from 'common-uicomponents/components/SnackBar';
import { BoostPortalParamsHandler } from '../helpers/BoostPortalParamsHandler';
import { TrackingFactorySingleton } from '../tracking/TrackingFactorySingleton';
import { Select } from '@vaadin/select';
import { TrackingEvent } from '../tracking/TrackingEvent';
import { BoostPortalTranslateMixin } from '../translation/TranslateBoostPortalMixin';
let BoostPortalChooseDepartment = class BoostPortalChooseDepartment extends BoostPortalTranslateMixin(litReduxBoostPortalMixin(LitElement)) {
    constructor() {
        super(...arguments);
        this.departments = [];
        this.isDirectLink = false;
        this.availableDepartments = [];
        this.isCreateProfileView = false;
        this.disabled = false;
        this.showHelperText = true;
    }
    static get is() {
        return 'boost-portal-choose-department';
    }
    static get styles() {
        return css `
            vaadin-select,
            vaadin-text-field {
                width: 100%;
            }

            h4 {
                color: var(--boost-font-color-dark);
                font-weight: 500;
                margin-bottom: 10px;
            }

            vaadin-text-field[id='department-name'] > input:disabled {
                --lumo-disabled-text-color: #262626;
            }

            .department-card {
                padding: 1rem;
                color: var(--portalCardForeground, #111);
                background-color: var(--portalCardBackground, #fefefe);
                border-radius: 4px;
                cursor: pointer;
                box-shadow:
                    rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
                    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
                position: relative;
            }

            .department-card:hover {
                background-color: var(--portalCardBackgroundHover, #ececec);
                transition: 300ms ease-out;
            }

            .departments-container {
                display: flex;
                flex-direction: column;
                gap: 6px;
            }

            .check {
                display: block;
                position: absolute;
                top: -4px;
                color: #f6f6f6;
                right: -10px;
                background-color: var(--portalButtonSuccessBackground, #32be69) !important;
                border-radius: 50%;
                width: 30px;
                height: 30px;
            }

            .check svg {
                fill: var(--portalButtonSuccessForeground, #74ff74);
            }

            @media only screen and (max-width: 1100px) {
                .check {
                    top: -10px;
                    width: 26px;
                    height: 26px;
                }

                svg {
                    width: 26px;
                    height: 26px;
                }
            }
        `;
    }
    /** @override */ render() {
        return html `
            ${this.selectedDepartmentId
            ? html `<div style="margin-bottom:25px;"></div>`
            : html `${this.isCreateProfileView
                ? html `<h4 style="padding:16px 0;">
                            ${this.boostTranslate('choose-department-for-profile')}
                        </h4>`
                : html `<h4 style="padding:16px 0;">
                            ${this.boostTranslate('choose-department-for-membership')}
                        </h4>`}`}

            <div class="departments-container">
                ${this.selectedDepartmentId
            ? html ` <cerum-form-label>${this.boostTranslate('selected-department')}</cerum-form-label>
                          ${this._renderDepartmentCard(undefined, this.selectedDepartmentId)}`
            : this._renderDepartmentSelection(this.departments)}
            </div>
        `;
    }
    _renderDepartmentSelection(departments) {
        if (departments.length === 1) {
            return this._renderDepartmentCard(departments[0]);
        }
        return html `${this.departments.map((department) => this._renderDepartmentCard(department))}`;
    }
    _renderDepartmentCard(department, selectedDepartmentId, selected) {
        if (selectedDepartmentId) {
            department = this.departments.find((findDepartment) => findDepartment.id === selectedDepartmentId);
            selected = true;
        }
        return html `<div
            class="department-card"
            @click="${() => { var _a; return this._setSelectedDepartment((_a = department === null || department === void 0 ? void 0 : department.id) !== null && _a !== void 0 ? _a : undefined); }}"
        >
            ${department === null || department === void 0 ? void 0 : department.navn}
            ${(department === null || department === void 0 ? void 0 : department.adresse) && department.sted
            ? html `<div style="font-size: 13px;">
                      <span>${department.adresse + ','}</span> <span>${department.sted}</span>
                  </div>`
            : ''}
            ${selected
            ? html `<div class="check">
                      <svg
                          xmlns="http://www.w3.org/2000/svg"
                          version="1.1"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          xmlns:svgjs="http://svgjs.com/svgjs"
                          viewBox="0 0 140 140"
                          width="30"
                          height="30"
                      >
                          <g transform="matrix(5.833333333333333,0,0,5.833333333333333,0,0)">
                              <path
                                  d="M18.48,6.449a1.249,1.249,0,0,0-1.747.265l-5.924,8.04L7.042,11.74a1.251,1.251,0,0,0-1.563,1.953l4.783,3.826a1.263,1.263,0,0,0,1.787-.235l6.7-9.087A1.25,1.25,0,0,0,18.48,6.449Z"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="0"
                              ></path>
                          </g>
                      </svg>
                  </div>`
            : ''}
        </div>`;
    }
    _setSelectedDepartment(selectedDepartmentId) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            if (!selectedDepartmentId || this.isDirectLink) {
                return;
            }
            if (selectedDepartmentId === this.selectedDepartmentId) {
                this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId());
                this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId());
                return;
            }
            const departmentName = (_b = (_a = this.departments.find((department) => department.id === selectedDepartmentId)) === null || _a === void 0 ? void 0 : _a.navn) !== null && _b !== void 0 ? _b : '';
            // Tracking events må legges inn på strategiske plasser i løypen
            TrackingFactorySingleton.getTracker().completedEvent(TrackingEvent.SelectedDepartment, {
                departmentId: selectedDepartmentId,
                departmentName,
            });
            this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(selectedDepartmentId));
            const departmentId = BoostPortalParamsHandler.getParameter('departmentId');
            if (departmentId) {
                this.dispatch(BoostPortalStore.Actions.SetSelectedMembershipId());
            }
        });
    }
    _tokenObserver() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.token) {
                return;
            }
            const departmentsResult = yield MembersignupAPI.getV1BoostsignupDepartments();
            if (isSuccessHTTP(departmentsResult)) {
                if (this.availableDepartments.length === 1) {
                    const availableDepartment = departmentsResult.find((department) => department.id === this.availableDepartments[0]);
                    if (availableDepartment && availableDepartment.id) {
                        this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(availableDepartment.id));
                    }
                }
                else {
                    if (departmentsResult.length === 1 && departmentsResult[0].id) {
                        this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(departmentsResult[0].id));
                    }
                }
                this.dispatch(BoostPortalStore.Actions.SetDepartments(departmentsResult));
            }
            else {
                SnackBar.pushError(departmentsResult.error);
            }
            const departmentId = BoostPortalParamsHandler.getParameter('departmentId');
            if (departmentId && parseInt(departmentId, 0)) {
                this.dispatch(BoostPortalStore.Actions.SetSelectedDepartmentId(parseInt(departmentId, 0)));
            }
        });
    }
    _isDirectLinkObserver() {
        if (this.isDirectLink) {
            this.disabled = true;
        }
    }
    /** @override */ updated(changedProperties) {
        changedProperties.forEach((_oldValue, propertyName) => {
            switch (propertyName) {
                case 'isDirectLink':
                    this._isDirectLinkObserver();
                    break;
                case 'token':
                    this._tokenObserver();
                    break;
            }
        });
        super.updated(changedProperties);
    }
};
BoostPortalChooseDepartment._deps = [Select];
__decorate([
    reduxBind(BoostPortalStore.path('departments')),
    state(),
    __metadata("design:type", Array)
], BoostPortalChooseDepartment.prototype, "departments", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('selectedDepartmentId')),
    state(),
    __metadata("design:type", Number)
], BoostPortalChooseDepartment.prototype, "selectedDepartmentId", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('isDirectLink')),
    state(),
    __metadata("design:type", Boolean)
], BoostPortalChooseDepartment.prototype, "isDirectLink", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('availableDepartments')),
    state(),
    __metadata("design:type", Array)
], BoostPortalChooseDepartment.prototype, "availableDepartments", void 0);
__decorate([
    reduxBind(BoostPortalStore.path('token')),
    state(),
    __metadata("design:type", String)
], BoostPortalChooseDepartment.prototype, "token", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalChooseDepartment.prototype, "isCreateProfileView", void 0);
__decorate([
    property({ type: Boolean }),
    __metadata("design:type", Boolean)
], BoostPortalChooseDepartment.prototype, "disabled", void 0);
__decorate([
    property({ type: Boolean, attribute: 'show-helper-text' }),
    __metadata("design:type", Boolean)
], BoostPortalChooseDepartment.prototype, "showHelperText", void 0);
BoostPortalChooseDepartment = __decorate([
    customElement(BoostPortalChooseDepartment.is)
], BoostPortalChooseDepartment);
export { BoostPortalChooseDepartment };
